import type { ReactNode } from 'react';
import U2000RequireRole from '../u2000Core/components/controls/U2000RequireRole';
import U2106, { U2106ROLES } from './U2106';
import U2106AiUsageView from './components/U2106AiUsageView';
import U2106ChangePasswordForm from './components/U2106ChangePasswordForm';
import U2106ProfileForm from './components/U2106ProfileForm';

interface RouteObject {
  path?: string;
  index?: boolean;
  element?: ReactNode;
  children?: RouteObject[];
}

const U2106Routes: RouteObject[] = [
  {
    path: 'U2106',
    element: <U2106 />,
    children: [
      {
        path: 'profile',
        element: <U2000RequireRole allowedRoles={[U2106ROLES.READ]} />,
        children: [{ index: true, element: <U2106ProfileForm /> }],
      },
      {
        path: 'password',
        element: <U2000RequireRole allowedRoles={[U2106ROLES.CHANGEPASSWORD]} />,
        children: [{ index: true, element: <U2106ChangePasswordForm /> }],
      },
      {
        path: 'ai-usage',
        element: <U2000RequireRole allowedRoles={[U2106ROLES.READ]} />,
        children: [{ index: true, element: <U2106AiUsageView /> }],
      },
    ],
  },
];

export default U2106Routes;
